import { Features } from '../features';
import { Permissions } from '../permissions';
import { BaseModel } from './base.model';

const LOGO_PROJECT_PEARLS = 'project_pearls' as const;

export const Logo = {
  [LOGO_PROJECT_PEARLS]: LOGO_PROJECT_PEARLS,
};

export type Logo = keyof typeof Logo;

const STEP_TYPE_FORMS = 'forms' as const;
const STEP_TYPE_CALENDAR = 'calendar' as const;

export const ProjectType = {
  [STEP_TYPE_FORMS]: STEP_TYPE_FORMS,
  [STEP_TYPE_CALENDAR]: STEP_TYPE_CALENDAR,
};

export type ProjectType = keyof typeof ProjectType;

const EXTENSION_ATTRIBUTE_ICON_HOSPITAL = 'hospital' as const;
const EXTENSION_ATTRIBUTE_ICON_INFO = 'info' as const;

export const ExtensionAttributeIcon = {
  [EXTENSION_ATTRIBUTE_ICON_HOSPITAL]: EXTENSION_ATTRIBUTE_ICON_HOSPITAL,
  [EXTENSION_ATTRIBUTE_ICON_INFO]: EXTENSION_ATTRIBUTE_ICON_INFO,
};

export type ExtensionAttributeIcon = keyof typeof ExtensionAttributeIcon;

const CONTACT_ICON_WOMAN = 'woman' as const;
const CONTACT_ICON_MAN = 'man' as const;
const CONTACT_ICON_GENERIC = 'generic' as const;

export const ContactIcon = {
  [CONTACT_ICON_WOMAN]: CONTACT_ICON_WOMAN,
  [CONTACT_ICON_MAN]: CONTACT_ICON_MAN,
  [CONTACT_ICON_GENERIC]: CONTACT_ICON_GENERIC,
};

export type ContactIcon = keyof typeof ContactIcon;

type ExtensionAttribute = {
  fieldKey: string;
  fieldDescription: string;
};

type ProjectCustomizations = {
  contactToday: {
    firstContact: {
      label: string;
      noResult: string;
    };
    reminder: {
      label: string;
      noResult: string;
    };
  };
  deliveredResponseToday: {
    title: string;
    description: string;
    nothingPendingLabel: string;
  };
  contact: {
    extensionAttributes: ExtensionAttribute[];
    useSequence: boolean;
    useEmail: boolean;
    useWhatsApp: boolean;
  };
  contactSearch: {
    collectLabels: {
      successfullyAt: string;
    };
    contactIcon: ContactIcon;
    referenceDateLabel: string;
    extensionAttributesLabel: string;
    extensionAttributesIcon: ExtensionAttributeIcon | null;
  };
};

type ProjectPermissions = {
  [Permissions.ALLOW_REGISTER_RESPONSE]: boolean;
  [Permissions.ALLOW_REGISTER_RESPONSE_OVERDUE]: boolean;
};

type ProjectStepCollectModel = {
  id: string;
  collectionName: string;
  number: number;
  name: string;
  description?: string;
  advanceDays: number;
  awaitingDays: number;
  permissions?: ProjectPermissions;
};

type ProjectModel = BaseModel<string> & {
  id: string;
  collectionName: string;
  isProduction: boolean;
  /**
   * Projeto encerrado: a interface inteira passa a somente leitura, acima do
   * que o perfil do usuário permitiria.
   *
   * Opcional porque os projetos que já existem nascem sem o campo, e ausente
   * tem o mesmo peso de `false` -- nenhum deles muda de comportamento ao
   * subir esta versão.
   */
  isArchived?: boolean;
  logo: string | null;
  name: string;
  type: ProjectType;
  firstCollect: 1 | 2;
  features: Features[];
  collects: Record<string, ProjectStepCollectModel>;
  customizations: ProjectCustomizations;
  permissions: ProjectPermissions;
};

export type { ExtensionAttribute, ProjectCustomizations, ProjectModel, ProjectPermissions, ProjectStepCollectModel };
